import React, { Component } from 'react';
import Axios from 'axios';
import  { Link  } from 'react-router-dom';
import { API_URL } from '../config/constants.js';
import Spinner from '../includes/Spinner.component';
const base_api_url = API_URL;
const axiosConfig = {
	  'Content-Type': 'multipart/form-data',
	  "Access-Control-Allow-Origin": "*",
}
export default class verifyEmailID extends Component {
	constructor(props) {
		super(props);
		this.state = {
		  msgtype: null,
		  message:null,
		  loading:true,
		}
	}
	
	componentDidMount(){
		document.title = "CONQER Music - Email Verification";
		this.activationfunc();
	}
	
	activationfunc = () =>{
		const verificationtoken = this.props.match.params.code;		
		
		const obj = {
			activation_code:verificationtoken
		}
		
		Axios.post(base_api_url+'email-verify.php', obj, {axiosConfig})
		.then(
			(res) => {console.log(res.data);
				if(res.data.res_status==200){
					
					this.setState({
						loading:false,
						msgtype: 'Congratulations!',						
						message: 'Your email id has been successfully verified. You can now log in using updated email id.'
					});
					
				}else if(res.data.res_status==402){
					this.setState({
						loading:false,
						msgtype: 'Error!',						
						message: 'Account is already activated.'
					});
				}else{
					//console.log(res.data);
					this.setState({
						msgtype: 'Error!',
						loading:false,
						message: 'Account activation is failed, please try again later!'
					})
				}
			}
		);
	}
	
	render() {
		if(this.state.loading==true){
			return <Spinner />;
		}
		return (
			<React.Fragment>
				<section className="become-artist-form">
					<div className="container">
						<div className="become-artist-part">
							<div className="row">
								<div className="contents_right col-md-12">
									<h1 className="white-heading">{this.state.msgtype}</h1>
									<div className="row">
										<div className="col-md-12">
											<p className="big-white-text">
											{this.state.message}</p>
											<p className="big-white-text"><Link to={'/login'}>Click here to Login</Link></p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</React.Fragment>
		)
	}
}